(ns machtfit.stepchall.message
  (:require [goog.string :as gstring]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.stepchall.api :as api]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.modal :as modal]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(def ^:private send-message-path
  [:ui :stepchall :send-message])

(rf/reg-event-db ::send-message-team-clicked
  (fn [db _]
    (assoc-in db send-message-path {:type :team})))

(rf/reg-event-db ::send-message-team-member-clicked
  (fn [db [_ {:keys [id nickname]}]]
    (assoc-in db send-message-path {:type :team-member
                                    :receiver-participant-id id
                                    :receiver-name nickname})))

(rf/reg-event-db ::cancel-send-message-modal-clicked
  (fn [db _]
    (update-in db [:ui :stepchall] dissoc :send-message)))

(defn ^:private handle-unknown-error [db error-data]
  (js/console.error "Unexpected error while sending message:"
                    (str error-data))
  (assoc-in db (conj send-message-path :error-message)
            {:de "Unbekannter Fehler, bitte versuche es später noch einmal."
             :en "Unknown error, please try again later."}))

(rf/reg-event-db ::on-send-message-error
  (fn [db [_ error-data]]
    (handle-unknown-error db error-data)))

(rf/reg-event-db ::on-send-message-response
  (fn [db [_ response]]
    (let [result (-> response :result :stepchall-result)
          error-message (-> result :error :name)]
      (cond
        (:success result) (assoc-in db (conj send-message-path :message-sent?)
                                    true)
        (= error-message
           "no-message") (assoc-in db (conj send-message-path :error-message)
                                   {:de "Bitte gib eine Nachricht ein."
                                    :en "Please enter a message."})
        (= error-message
           "receiver-not-on-same-team") (assoc-in db (conj send-message-path :error-message)
                                                  {:de "Der angegebene Empfänger ist nicht mehr in deinem Team."
                                                   :en "The selected receiver is not on your team anymore."})
        :else (handle-unknown-error db response)))))

(rf/reg-event-fx ::confirm-send-team-message-clicked
  (fn [{:keys [db]} _]
    (let [message (get-in db (conj send-message-path :message))]
      {:post (api/request
              db
              {:function :stepchall-send-message-to-team
               :params {:message message}
               :on-success #(rf/dispatch [::on-send-message-response %])
               :on-error #(rf/dispatch [::on-send-message-error %])})})))

(rf/reg-event-fx ::confirm-send-team-member-message-clicked
  (fn [{:keys [db]} _]
    (let [{:keys [message
                  receiver-participant-id]} (get-in db send-message-path)]
      {:post (api/request
              db
              {:function :stepchall-send-message-to-team-member
               :params {:message message
                        :receiver_participant_id receiver-participant-id}
               :on-success #(rf/dispatch [::on-send-message-response %])
               :on-error #(rf/dispatch [::on-send-message-error %])})})))

(rf/reg-event-db ::set-message
  (fn [db [_ message]]
    (assoc-in db (conj send-message-path :message) message)))

(defn- send-team-message-modal-content [{:keys [success-message
                                                on-click-send-message]}]
  (if @(rf/subscribe [:get [:ui :stepchall :send-message :message-sent?]])
    [:div
     [:div {:style {:text-align "center"
                    :margin-top "6rem"}}
      [:div
       [icons/message-sent]]
      [:div {:style {:display "inline-block"
                     :width "12.125rem"
                     :margin-top "1rem"}}
       [:h2 success-message]]]]

    [:div
     [widgets/textarea {:value @(rf/subscribe [:get [:ui :stepchall :send-message :message]])
                        :style {:width "100%"
                                :height "8rem"
                                :border-radius "8px"
                                :outline 0
                                :resize "none"
                                :padding "1rem"}
                        :on-save #(rf/dispatch [::set-message %])}]
     (when-let [error-message (t @(rf/subscribe [:get [:ui :stepchall :send-message :error-message]]))]
       [widgets/error-messages [error-message]])
     [:button.sc_button {:on-click (fn [dom-event]
                                     (.preventDefault dom-event)
                                     (on-click-send-message))}
      (t {:de "E-Mail senden"
          :en "Send email"})]]))

(defn- send-team-message-modal []
  (let [message-sent? @(rf/subscribe [:get [:ui :stepchall :send-message :message-sent?]])]
    [modal/modal {:title (when-not message-sent?
                           (t {:de "E-Mail an mein Team"
                               :en "Email to my team"}))
                  :content [(partial send-team-message-modal-content
                                     {:success-message (t {:de "Deine E-Mail wurde an dein Team gesendet"
                                                           :en "Your email was sent to your team"})
                                      :on-click-send-message #(rf/dispatch [::confirm-send-team-message-clicked])})]
                  :close-button {:on-click #(rf/dispatch [::cancel-send-message-modal-clicked])}}]))

(defn- send-team-member-message-modal []
  (let [message-sent? @(rf/subscribe [:get [:ui :stepchall :send-message :message-sent?]])
        receiver-name @(rf/subscribe [:get [:ui :stepchall :send-message :receiver-name]])]
    [modal/modal {:title (when-not message-sent?
                           (gstring/format (t {:de "E-Mail an %s"
                                               :en "Email to %s"}) receiver-name))
                  :content [(partial send-team-message-modal-content
                                     {:success-message (gstring/format (t {:de "Deine E-Mail wurde an %s geschickt"
                                                                           :en "Your email was sent to %s"}) receiver-name)
                                      :on-click-send-message #(rf/dispatch [::confirm-send-team-member-message-clicked])})]
                  :close-button {:on-click #(rf/dispatch [::cancel-send-message-modal-clicked])}}]))

(defn send-message-modal []
  (case @(rf/subscribe [:get [:ui :stepchall :send-message :type]])
    :team [send-team-message-modal]
    :team-member [send-team-member-message-modal]
    nil))

(defn send-message-team-button []
  [:div.sc_team-send-message-all
   {:on-click #(rf/dispatch [::send-message-team-clicked])}
   [icons/send-message-all]])

(defn send-message-team-member-button [team-member]
  [:div.sc_team-send-message-one
   {:on-click #(rf/dispatch [::send-message-team-member-clicked team-member])}
   [icons/send-message-one]])
